/**
 * Whether this tenant should get the un-entitled treatment for Premium-gated hub
 * features — a locked editor, an upsell in place of controls, and so on.
 *
 * `=== false`, not `!isPremiumEntitled`: the flag is tri-state and `undefined`
 * means "unknown", which must never lock anything — that would take paid
 * features away from entitled customers.
 *
 * Help hubs only. `hubType` comes from the bootstrap query rather than `envJson`,
 * so it is reliable in both the view and edit experiences — Customer Service
 * (`CUSTOMER_SERVICE`) hubs are never affected regardless of how they were routed.
 *
 * Reads `HubContext` rather than `useProductDependencies`, which is only mounted
 * around hub *extensions*, not the editor or its config panels.
 */
import { useContext } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { HubContext } from '../../utils';

export const useShouldShowPremiumUpsell = (): boolean => {
	const ctx = useContext(HubContext);
	if (!ctx) {
		// e.g. Confluence Company Hub — never lock.
		return false;
	}
	if (ctx.hubType !== 'HELP_HUB') {
		return false;
	}
	return ctx.isPremiumEntitled === false && fg('hubs_premium_upsell');
};
